import React, { useEffect, useState } from 'react'
import WithHOC from './actions'
import { Table, Typography, Button, Row, Col, Modal, Space } from 'antd'
import LoadingOverlay from 'components/LoadingOverlay'
import { useTranslation } from "react-i18next";
import { Container } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

import {
  PlusOutlined,
  EditTwoTone,
  DeleteTwoTone,
  CheckCircleTwoTone,
  CloudSyncOutlined,
  ArrowLeftOutlined,
 } from '@ant-design/icons'

import { getItem } from 'utils/tokenStore'
import AddDeviceConfigModal from './AddDeviceConfigModal'
import EditDeviceConfigModal from './EditDeviceConfigModal'
import PushStatusModal from './PushStatusModal'

const DeviceConfig = props => {
  const { t } = useTranslation();
  const { Title } = Typography
  const navigate = useNavigate()

  const [addVisible, setAddVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [pushStatusVisible, setPushStatusVisible] = useState(false);

  const showAddModal = () => {
    setAddVisible(true);
  };

  const closeAddModal = () => {
    setAddVisible(false);
  };

  const showEditModal = () => {
    setEditVisible(true);
  };

  const closeEditModal = () => {
    setEditVisible(false);
    props.onChangeHOC('selectedDeviceConfig', null);
    props.onChangeHOC('deviceConfigScope', null);
  };

  const showPushStatusModal = () => {
    setPushStatusVisible(true);
  };

  const closePushStatusModal = () => {
    setPushStatusVisible(false);
    props.onChangeHOC('selectedDeviceConfig', null);
    props.onChangeHOC('deviceConfigPushStatus', null);
  };

  const columns = [
    {
      key: "VERSION",
      title: t("DeviceConfigPage.table.version"),
      dataIndex: "VERSION",
      sorter: (a, b) => a.VERSION - b.VERSION,
    },
    {
      key: "DESCRIPTION",
      title: t("DeviceConfigPage.table.description"),
      dataIndex: "DESCRIPTION",
    },
    {
      key: "CreatedTime",
      title: t("DeviceConfigPage.table.created"),
      render: (_, deviceConfig) => (
        <>{deviceConfig.CREATED_TIME || '-'} </>
      ),
    },
    {
      key: "ACT",
      title: t("DeviceConfigPage.table.action"),
      render: (_, deviceConfig) => (
        <Space>
          <EditTwoTone onClick={() => {
            props.onChangeHOC('selectedDeviceConfig', deviceConfig);
            showEditModal();
          }} />

          <DeleteTwoTone onClick={() =>
            Modal.confirm({
              title: t("DeviceConfigPage.deleteModal.title"),
              content: t("DeviceConfigPage.deleteModal.content", { name: deviceConfig.VERSION }),
              okText: t("Confirm"),
              cancelText: t("Cancel"),
              onOk: () => props.deleteDeviceConfig(deviceConfig.VERSION),
            })
          } />

          <CheckCircleTwoTone onClick={() => {
            Modal.confirm({
              title: t("DeviceConfigPage.pushModal.title"),
              content: t("DeviceConfigPage.pushModal.content", { name: deviceConfig.VERSION }),
              okText: t("Confirm"),
              cancelText: t("Cancel"),
              onOk: () => props.pushDeviceConfig(deviceConfig.VERSION),
            })
          }} />

          <CloudSyncOutlined onClick={() => {
            props.onChangeHOC('selectedDeviceConfig', deviceConfig);
            showPushStatusModal();
          }} />
        </Space>
      ),
    },
  ];

  useEffect(() => {
    if (getItem("LOGIN_TOKEN")) {
      props.getDeviceConfigs()
      props.getDevices()
    }
  }, [])

  return (
    <Container>
      <Row style={{ alignItems: "center" }}>
        <Col sm={12}>
          <Space align="center">
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/dashboard/firmware')}
            />
            <Title level={4} style={{ margin: 0 }}>{t("DeviceConfigPage.title")}</Title>
          </Space>
        </Col>
        <Col sm={12}>
          <Button
            type="primary"
            size="large"
            icon={<PlusOutlined />}
            style={{ background: "#1890ff", borderColor: "#1890ff", float: "right" }}
            onClick={showAddModal}
          >
            {t("DeviceConfigPage.addDeviceConfig")}
          </Button>
        </Col>
      </Row>

      <Table
        dataSource={props.deviceConfigs}
        columns={columns}
        rowKey={"VERSION"}
        pagination={{
          pageSizeOptions: ["10", "20", "50"],
          showSizeChanger: true,
          defaultPageSize: 10,
          showTotal: (total, range) =>
            t("pagination.showTotal", { start: range[0], end: range[1], total }),
        }}
      />

      {props.onLoading && <LoadingOverlay />}

      {addVisible && (
        <AddDeviceConfigModal
          visible={addVisible}
          action={props.addDeviceConfig}
          close={closeAddModal}
        />
      )}

      {editVisible && (
        <EditDeviceConfigModal
          visible={editVisible}
          deviceConfig={props.selectedDeviceConfig}
          devices={props.devices}
          deviceConfigScope={props.deviceConfigScope}
          loadScope={props.getDeviceConfigScope}
          updateScope={props.updateDeviceConfigScope}
          close={closeEditModal}
        />
      )}

      {pushStatusVisible && (
        <PushStatusModal
          visible={pushStatusVisible}
          deviceConfig={props.selectedDeviceConfig}
          pushStatus={props.deviceConfigPushStatus}
          loadStatus={props.getDeviceConfigPushStatus}
          close={closePushStatusModal}
        />
      )}
    </Container>
  )
}

export default WithHOC(DeviceConfig)
